"use strict";

exports.__esModule = true;
exports.PATTERNS = void 0;

var _ItemTypes = require("../types/ItemTypes");

var _Identifiers = require("../types/Identifiers");

var _TagTypes = require("../types/TagTypes");

var _Props = _interopRequireDefault(require("../types/Props"));

var _props, _props2, _props3, _props4, _props5, _props6, _props7, _props8, _props9, _props10, _props11, _props12, _props13, _props14, _props15, _props16, _props17, _props18, _props19, _props20, _props21, _props22, _props23, _props24, _props25, _props26, _PATTERNS;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PATTERNS = (_PATTERNS = {}, _PATTERNS[_ItemTypes.ITEM_TYPES.STATIC_PAGE] = {
  tags: [{
    type: _TagTypes.TAG_TYPES.TITLE,
    children: '{{page.title}}'
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props = {}, _props[_Props["default"].NAME] = 'description', _props[_Props["default"].CONTENT] = "{{page.description}}", _props)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props2 = {}, _props2[_Props["default"].PROPERTY] = 'og:title', _props2[_Props["default"].CONTENT] = "{{@" + _Identifiers.IDENTIFIERS.TITLE + "}}", _props2)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props3 = {}, _props3[_Props["default"].PROPERTY] = 'og:description', _props3[_Props["default"].CONTENT] = "{{@" + _Identifiers.IDENTIFIERS.DESCRIPTION + "}}", _props3)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props4 = {}, _props4[_Props["default"].PROPERTY] = 'og:url', _props4[_Props["default"].CONTENT] = '{{page.url}}', _props4)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props5 = {}, _props5[_Props["default"].PROPERTY] = 'og:site_name', _props5[_Props["default"].CONTENT] = '{{site.name}}', _props5)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props6 = {}, _props6[_Props["default"].PROPERTY] = 'og:type', _props6[_Props["default"].CONTENT] = 'website', _props6)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props7 = {}, _props7[_Props["default"].PROPERTY] = 'og:image', _props7[_Props["default"].CONTENT] = '{{page.image}}', _props7)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props8 = {}, _props8[_Props["default"].PROPERTY] = 'og:image:width', _props8[_Props["default"].CONTENT] = '{{page.imageWidth}}', _props8)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props9 = {}, _props9[_Props["default"].PROPERTY] = 'og:image:height', _props9[_Props["default"].CONTENT] = '{{page.imageHeight}}', _props9)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props10 = {}, _props10[_Props["default"].PROPERTY] = 'fb:admins', _props10[_Props["default"].CONTENT] = "{{site.facebookAdminId}}", _props10)
  }, // TODO: Uncomment once twitter is added again
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:title',
  //     [PROPS.CONTENT]: `{{@${IDENTIFIERS.OG_TITLE}}}`,
  //   },
  // },
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:description',
  //     [PROPS.CONTENT]: `{{@${IDENTIFIERS.OG_DESCRIPTION}}}`,
  //   },
  // },
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:image',
  //     [PROPS.CONTENT]: `{{@${IDENTIFIERS.OG_IMAGE}}}`,
  //   },
  // },
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:site',
  //     [PROPS.CONTENT]: '{{site.name}}',
  //   },
  // },
  {
    type: _TagTypes.TAG_TYPES.LINK,
    props: (_props11 = {}, _props11[_Props["default"].REL] = 'canonical', _props11[_Props["default"].HREF] = '{{page.url}}', _props11)
  }]
}, _PATTERNS[_ItemTypes.ITEM_TYPES.STORES_PRODUCT] = {
  tags: [{
    type: _TagTypes.TAG_TYPES.TITLE,
    children: '{{product.name}} | {{site.name}}'
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props12 = {}, _props12[_Props["default"].NAME] = 'description', _props12[_Props["default"].CONTENT] = "{{product.description}}", _props12)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props13 = {}, _props13[_Props["default"].PROPERTY] = 'og:title', _props13[_Props["default"].CONTENT] = "{{@" + _Identifiers.IDENTIFIERS.TITLE + "}}", _props13)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props14 = {}, _props14[_Props["default"].PROPERTY] = 'og:description', _props14[_Props["default"].CONTENT] = "{{@" + _Identifiers.IDENTIFIERS.DESCRIPTION + "}}", _props14)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props15 = {}, _props15[_Props["default"].PROPERTY] = 'og:url', _props15[_Props["default"].CONTENT] = '{{product.url}}', _props15)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props16 = {}, _props16[_Props["default"].PROPERTY] = 'og:site_name', _props16[_Props["default"].CONTENT] = '{{site.name}}', _props16)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props17 = {}, _props17[_Props["default"].PROPERTY] = 'og:type', _props17[_Props["default"].CONTENT] = 'product', _props17)
  }, // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:title',
  //     [PROPS.CONTENT]: `{{@${IDENTIFIERS.OG_TITLE}}}`,
  //   },
  // },
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:description',
  //     [PROPS.CONTENT]: `{{@${IDENTIFIERS.OG_DESCRIPTION}}}`,
  //   },
  // },
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:image',
  //     [PROPS.CONTENT]: `{{@${IDENTIFIERS.OG_IMAGE}}}`,
  //   },
  // },
  // {
  //   type: TAG_TYPES.META,
  //   props: {
  //     [PROPS.NAME]: 'twitter:site',
  //     [PROPS.CONTENT]: '{{site.name}}',
  //   },
  // },
  {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props18 = {}, _props18[_Props["default"].NAME] = 'robots', _props18[_Props["default"].CONTENT] = 'index', _props18)
  }, {
    type: _TagTypes.TAG_TYPES.LINK,
    props: (_props19 = {}, _props19[_Props["default"].REL] = 'canonical', _props19[_Props["default"].HREF] = '{{product.url}}', _props19)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props20 = {}, _props20[_Props["default"].PROPERTY] = 'product:price:amount', _props20[_Props["default"].CONTENT] = '{{product.price}}', _props20)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props21 = {}, _props21[_Props["default"].PROPERTY] = 'product:price:currency', _props21[_Props["default"].CONTENT] = '{{product.currency}}', _props21)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props22 = {}, _props22[_Props["default"].PROPERTY] = 'og:availability', _props22[_Props["default"].CONTENT] = '{{product.availability}}', _props22)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props23 = {}, _props23[_Props["default"].PROPERTY] = 'og:image', _props23[_Props["default"].CONTENT] = '{{product.image.url}}', _props23)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props24 = {}, _props24[_Props["default"].PROPERTY] = 'og:image:width', _props24[_Props["default"].CONTENT] = '{{product.image.width}}', _props24)
  }, {
    type: _TagTypes.TAG_TYPES.META,
    props: (_props25 = {}, _props25[_Props["default"].PROPERTY] = 'og:image:height', _props25[_Props["default"].CONTENT] = '{{product.image.height}}', _props25)
  }, {
    type: _TagTypes.TAG_TYPES.SCRIPT,
    props: (_props26 = {}, _props26[_Props["default"].TYPE] = 'application/ld+json', _props26),
    children: "{\n          \"@context\": \"https://schema.org/\",\n          \"@type\": \"Product\",\n          \"name\": \"{{product.name}}\",\n          \"description\": \"{{product.description}}\",\n          \"sku\": \"{{product.sku}}\",\n          \"brand\": {\n            \"@type\": \"Thing\",\n            \"name\": \"{{site.businessName}}\"\n          },\n          \"image\": {\n            \"@type\": \"ImageObject\",\n            \"height\": \"{{product.image.height}}\",\n            \"width\": \"{{product.image.width}}\",\n            \"contentUrl\": \"{{product.image.url}}\",\n            \"representativeOfPage\": true,\n            \"name\": \"{{product.image.alt}}\",\n            \"thumbnail\": {\n              \"@type\": \"ImageObject\",\n              \"height\": \"{{product.thumbnail.height}}\",\n              \"width\": \"{{product.thumbnail.width}}\",\n              \"contentUrl\": \"{{product.thumbnail.url}}\",\n              \"name\": \"{{product.thumbnail.alt}}\"\n            }\n          },\n          \"Offers\": {\n            \"@type\": \"Offer\",\n            \"url\": \"{{product.url}}\",\n            \"priceCurrency\": \"{{product.currency}}\",\n            \"price\": \"{{product.price}}\",\n            \"Availability\": \"{{product.availability}}\",\n            \"seller\": {\n              \"@type\": \"Organization\",\n              \"name\": \"{{site.businessName}}\",\n              \"sameAs\": \"{{product.baseUrl}}\"\n            }\n          }\n        }"
  }]
}, _PATTERNS[_ItemTypes.ITEM_TYPES.DEFAULT] = {}, _PATTERNS);
exports.PATTERNS = PATTERNS;